import React from 'react';

import ButtonV3 from '@zola/zola-ui/src/components/ButtonV3/ButtonV3';

import { useCardSuiteDetails } from 'cards/components/common/Samples/util/hooks/useCardSuiteDetails';
import type { CardSuiteDetails } from 'cards/reducers/samplesFlow/types';
import type { SingleSampleAccessPointUIProps } from '../../../util/types';

import styles from './APWebsitePdp.module.less';

const APWebsitePdp: React.FC<SingleSampleAccessPointUIProps> = ({
  cardSuiteInfo,
  handleOpenModal,
}) => {
  const cardSuiteDetails: CardSuiteDetails = useCardSuiteDetails(cardSuiteInfo?.uuid);
  const cardSuitePrimaryColor = cardSuiteInfo?.sampleCard?.lead_card?.colors?.[0]?.value;
  const previewImage = () => {
    const imgSrc =
      cardSuitePrimaryColor &&
      cardSuiteDetails?.images_urls?.[cardSuitePrimaryColor]?.pdp_full_suite;
    return imgSrc ? <img src={imgSrc} alt="full suite preview" /> : <></>;
  };

  return (
    <div className={styles.apPdpPage}>
      <div className={styles.apPdpPageImgContainer}>{previewImage()}</div>
      <div className={styles.apPdpPageTextContainer}>
        <h2 className={styles.apPdpPageTitle}>Love it? Get the matching paper, too</h2>
        <p className={styles.apPdpPageText}>
          Live the suite life with coordinating save the dates, invites, place cards, and more.
        </p>
        <ButtonV3
          variant="secondary"
          role="button"
          onClick={(): void => {
            if (handleOpenModal) {
              handleOpenModal({ entryPoint: 'WEBSITE_PDP' });
            }
          }}
        >
          Order free samples
        </ButtonV3>
      </div>
    </div>
  );
};

export default APWebsitePdp;
